import { createSelector } from 'reselect';

import { emptySlice } from 'modules/auditModels/reducer/ui/select/stack';
import { getLocale } from 'modules/i18n/selectors/data';

import { getUI, getAll, getById as getAuditModelById } from './general';

const getProps = (_, props) => props;

const getSelect = createSelector(getUI, ui => ui.select);

const getSelectsRoot = createSelector(getSelect, select => select.stack);

const getSelectByToken = createSelector(getSelectsRoot, getProps, (state, token) => state[token] ?? emptySlice);

export const isInitialized = createSelector(getSelectsRoot, getProps, (state, token) => Boolean(state[token]));

export const getIds = createSelector(getSelectByToken, select => select.ids ?? []);

const getFilters = createSelector(getSelectByToken, select => select.filters);

export const isLoading = createSelector(getSelectByToken, select => select.isLoading);

export const getPage = createSelector(getSelectByToken, select => select.page ?? {});

export const hasNextPage = createSelector(getPage, page => page.number + 1 < page.totalPages);

export const getParams = createSelector(getPage, getFilters, getLocale, ({ size }, filters, language) => ({
  ...filters,
  size,
  language: language?.toUpperCase(),
}));

const toAssignmentOption = auditModel =>
  auditModel && {
    ...auditModel,
    id: auditModel.auditModelId ?? auditModel.id,
    name: auditModel.title ?? auditModel.name,
  };

export const getPageNumber = createSelector(getPage, page => page?.number ?? 0);

export const getOptionById = createSelector(getAuditModelById, toAssignmentOption);

export const getOptions = createSelector(getAll, getIds, (collection, ids) =>
  ids.reduce((acc, auditModelId) => {
    const auditModel = collection[auditModelId];
    if (auditModel) {
      acc.push(toAssignmentOption(auditModel));
    }
    return acc;
  }, []));
